export default __webpack_public_path__ + "static/media/issue-tracking-orange.d315a764.svg";